import type { ChallengeRecord } from "../challenges/storage"
import type { PlayerProfile } from "../schemas"

export function summarizeAdminUsage(
  profiles: readonly PlayerProfile[],
  challenges: readonly ChallengeRecord[],
) {
  const latestChallengeAt =
    challenges
      .map((challenge) => challenge.updatedAt)
      .sort((left, right) => right.localeCompare(left))[0] ?? null

  return {
    totalProfiles: profiles.length,
    adminProfiles: profiles.filter((profile) => profile.role === "admin")
      .length,
    playerProfiles: profiles.filter((profile) => profile.role === "player")
      .length,
    totalChallenges: challenges.length,
    pendingChallenges: challenges.filter(
      (challenge) => challenge.status === "pending",
    ).length,
    acceptedChallenges: challenges.filter(
      (challenge) => challenge.status === "accepted",
    ).length,
    declinedChallenges: challenges.filter(
      (challenge) => challenge.status === "declined",
    ).length,
    cancelledChallenges: challenges.filter(
      (challenge) => challenge.status === "cancelled",
    ).length,
    activePlayers: new Set(
      challenges.flatMap((challenge) => [
        challenge.challengerTag,
        challenge.challengedTag,
      ]),
    ).size,
    latestChallengeAt,
  }
}
